import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';

const log = debug('ProductPagesSearch:Utils:Facets');

class Facets {
	/**
	 * @param {Object} options
	 * @param {string} [options.categories]
	 * @param {number} [options.productsPerPage]
	 * @param {number} [options.searchWord]
	 * 
	 * @returns {string} facet querystrings
	 */
	static get({ categories, productsPerPage, searchWord }) {
		let facets = '';

		if (searchWord !== undefined) {
			facets += `search=${encodeURIComponent(searchWord)}`;
		} 

		let startPage = queryString.Get('page');
		if (typeof startPage !== 'undefined') {
			facets += `&startPage=${startPage}`;
		}

		let categoriesQuery = queryString.Get('cat');
		if (typeof categoriesQuery !== 'undefined' && categoriesQuery !== '' && categoriesQuery.split('|').indexOf('alle') === -1) {
			facets += `&categories=${categoriesQuery}`;
		} else if (categories !== undefined) {
			facets += `&categories=${categories}`;
		}

		if (productsPerPage !== undefined) {
			facets += `&numberOfResults=${productsPerPage}`;
		}

		let tradeLabels = queryString.Get('lab');
		if (typeof tradeLabels !== 'undefined' && tradeLabels.split('|').indexOf('alle') === -1) {
			facets += `&tradeLabels=${tradeLabels}`;
		}

		let sorting = queryString.Get('srt');
		if (typeof sorting !== 'undefined') {
			facets += `&sort=${sorting}`;
		}

		return facets;
	}
}

export default Facets;
